import React, { useState } from 'react';
import styles from '../../../styles/hardware-partners/hardwarePartner.module.css';
import { AdvanceAnalyticsBanner, BlackCustomButton, HardwareFeatures, HardwareTab, MarqueeComponentHomePage, Tabs, TransparentCustomButton, WhiteCustomButton } from '@/components/qbStrap';
import Image from 'next/image';
import OutletFeatures from '@/components/common/OutletFeatures';
import { ClientsArr1, testimonialData, zomatoFeatures, videoTestimonial, zomatoFAQ, swiggyFAQ, swiggyFeatures , getTitleContent } from '@/constants/common';
import ThreeStepForm from '@/components/common/ThreeStepForm';
import TestimonialSection from '@/components/common/TestimonialSection';
import TrustFactor from '@/components/common/TrustFactor';
import FrequentQuestions from '@/components/homePage/FrequentQuestions';
import PersonalisedDemoBanner from '@/components/common/PersonalisedDemoBanner';
import VerificationPopup from '@/components/modals/VerificationPopup';
import { useRouter } from 'next/router';
import content from '../../../language/ENGLISH.json';

const DesktopPaytm = () => {

    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const router = useRouter();

    const { commonMarqueTitle } = getTitleContent();

    const PaytmMLoyalFeatures = [
        {
            id: 1,
            image: "/assets/PaytmMLoyal/CRM-Membership.svg",
            title: "CRM & Membership Management",
            desc: "Convert walk-in customers into loyal regulars by offering them rewards like discounts, vouchers, special offers, and giveaways. With QueueBuster & Paytm m'Loyal, you can do:",
            bgColor: "#8ae4f626",
            imageHeight: "55rem",
            mobImageHeight: "20rem",
            btnText: "Speak with an expert",
            tagColor: "#C9F6FF",
            points: [
                <> <b>Manage Store Accounts – </b>Oversee and organize your store's account details in one place</>,
                <>  <b>Organize Loyalty Member Databases –</b>Keep loyalty member information structured and easily accessible.</>,
                <> <b>Run Discounts, Offers & Referral Programs –</b> Create rewarding programs to engage and retain customers.</>,
                <><b>Build Rich Customer Profiles & Loyalty Points –</b>Enhance customer profiles and track loyalty points for a more personalized experience.</>
            ]
        },
        {
            id: 2,
            image: "/assets/PaytmMLoyal/connectors.svg",
            title: "OmniChannel Connectors",
            desc: "Paytm m’Loyal integrates easily with QueueBuster POS and other offline systems to unify customer touchpoints. With features like built-in widgets, utilities, and data capture tools, it’s easier than ever to gather essential customer details.",
            bgColor: "#F2FDEB",
            imageHeight: "46rem",
            mobImageHeight: "16rem",
            btnText: "Request a callback",
            tagColor: "#d4f4bf",
            points: [
                <><b>Integrate Across All Channels - </b>Connects with QueueBuster POS and other systems to create a seamless experience.</>,
                <><b>Capture Key Customer Data –</b>Built-in tools collect and organize customer details at each interaction point.</>,
                <><b>Gain Customer Insights –</b>Analyze customer behavior for more targeted engagement.</>  
            ]
        },
        {
            id: 3,
            image: "/assets/PaytmMLoyal/cec.svg",
            title: "Customer Engagement Cloud Solutions (CEC)",
            desc: "The Customer Engagement Cloud (CEC)™ is a tool for real-time tracking and one-on-one campaign management. With advanced options for clustering data, you can track the ROI and refine campaigns based on performance.",
            bgColor: "#FCF7FF",
            imageHeight: "44rem",
            mobImageHeight: "22rem",
            btnText: "Talk to an expert",
            tagColor: "#e6ccf6",
            points: [
                <><b> Track Campaign Performance in Real-Time –</b>Get instant insights to make better decisions.</>,
                <><b>Advanced Data Clustering –</b>Tailor campaigns by grouping data with endless possibilities.</>,
                <><b>  Optimize Future Campaigns –</b>Real-time ROI helps you adjust future strategies based on what works.</>
                  
            ]
        },
    ];

    const PaytmMloyalFAQ = [
        {
            para: (
                <span style={{ width: "90%" }}>
                     What is the Paytm m’Loyal Program, and how does it benefit my business with QueueBuster POS integration?
                    
                </span>
            ),
            des: " The Paytm m'Loyal Program is a loyalty and CRM system that integrates with QueueBuster POS, making it easy to track and reward loyal customers. This setup helps build strong customer relationships, increases repeat business, and supports business growth through personalized rewards.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   How does the CRM and Member Management work in the Paytm m’Loyal Program?
                </span>
            ),
            des: "The CRM and Member Management features allow you to organize loyalty member data, store accounts, and manage feedback and referrals. It also ensures data accuracy and builds detailed customer profiles, turning occasional visitors into regular customers through tailored rewards and offers.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can the loyalty program connect across multiple sales channels?
                 </span>
            ),
            des: "Yes, Paytm m’Loyal’s OmniChannel Connectors integrate with QueueBuster POS and other offline systems, unifying customer interactions across multiple channels for a smooth loyalty experience.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is the Customer Engagement Cloud (CEC)™?
                </span>
            ),
            des: "The Customer Engagement Cloud (CEC)™ is a campaign and ROI tracking tool in Paytm m’Loyal that helps you run real-time, one-on-one campaigns. It allows data clustering for targeted campaigns and provides insights on ROI for each cluster, guiding future campaign strategies.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How can I track the performance of loyalty and marketing campaigns in real time?
                </span>
            ),
            des: "CEC lets you track campaign performance instantly. You can see the ROI for each customer group, helping you evaluate campaigns and plan future ones based on data-driven results.",
            id: 5,
            activeIndex: 0,
        },

        {
            para: (
                <span style={{ width: "90%" }}>
                    Is customer data kept private when using OmniChannel Connectors?
 
                </span>
            ),
            des: "Yes, data privacy is a priority. The system includes data sanitization and securely manages customer information across all channels to ensure compliance and privacy.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What rewards can I offer through this loyalty program?
                </span>
            ),
            des: "You can offer a range of rewards, including discounts, vouchers, giveaways, and customized offers to keep customers engaged and encourage loyalty.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   How does the feedback and referral system work in the loyalty program?
                </span>
            ),
            des: "The CRM allows you to gather customer feedback and run referral programs, motivating loyal customers to bring in new ones, which helps grow your customer base and improve satisfaction.",
            id: 8,
            activeIndex: 0,
        },
        
    ];

    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section} style={{ alignItems: "end" }}>
                <div className={styles.text_container}>
                    <div className={styles.hardware_logo} style={{ width: "10rem",  height:'7rem'}}><Image src="/assets/PaytmMLoyal/paytm.webp" alt="ADSR" fill /></div>
                    <h1 className={styles.page_heading}>
                        <span className={styles.small_black_text}>Integrate Paytm m’Loyal</span><br />
                        <span className={styles.black_text}>with</span><span className={styles.blue_text}> QueueBuster POS</span>
                    </h1>
                    <p className={styles.page_desc}>Using Paytm m'Loyal for CRM? Integrate it seamlessly with QueueBuster POS for a complete POS experience that helps grow your business by fostering strong customer relationships and driving repeat visits. Make every customer interaction count!.</p>

                    <div className={styles.btn_container}>
                        <BlackCustomButton text="Try It Free" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("14 Days free trial"))} />
                        <TransparentCustomButton text="Contact Sales" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("Contact Sales"))} />
                    </div>
                </div>
                <div className={styles.hero_img} style={{ height: "40rem", width: "50rem" }}><Image src="/assets/PaytmMLoyal/hero-paytm.svg" alt="tvse" fill /></div>
            </div>

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.portable_devices}>
            <div className={styles.section_heading}><h3> Tap, Grow, Reward – Loyalty Reloaded with QB POS & Paytm</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>  
                {/* <h2>Tap, Grow, Reward – Loyalty Reloaded with QB POS & Paytm</h2> */}
                <HardwareFeatures features={PaytmMLoyalFeatures} setDemoModal={setDemoModal} setHeading={setHeading} />
            </div>
            <AdvanceAnalyticsBanner setDemoModal={setDemoModal} setHeading={setHeading} />
            <div style={{ margin: "0 9.3rem" }}><ThreeStepForm /></div>

            <div style={{ margin: "5rem 6rem" }}><TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /></div>
            <TrustFactor />

            <FrequentQuestions FaqTableData={PaytmMloyalFAQ} heading={"Frequently Asked Questions for QB ADSR Integrated POS Software"} />
            <div style={{ margin: "0 9.3rem" }}><PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} /></div>
        </>
    )
}

export default DesktopPaytm